import { HttpClient } from '@/shared/lib/http-client';

export const findVehicleMake = async (make) => {
  const response = await HttpClient.get('/directories/cars/find-mark', {
    name: make,
  });

  return response.data;
};
